import React from "react"
import { Layout } from "../components/Layout"
import { SEO } from "../components/SEO"
import { CTABlock } from "../components/CTABlock"
import { AffiliateList } from "../components/AffiliateList"
import serviceOculXs from "../assets/images/@1x-oculoplastic-xs.jpg"
import serviceOphthXs from "../assets/images/@1x-ophthalmology-xs.jpg"
import serviceAesthXs from "../assets/images/@1x-aesthetics-xs.jpg"
import containerClasses from "../styles/container.module.css"

const AllServices = () => {
  return (
    <Layout page="All Services">
      <SEO
        title="All Services | Oculoplastic Surgery, Ophthalmology & Aesthetics | Dr Hawkes Clinic"
        description="Explore the full range of specialist eye surgery, ophthalmology and facial aesthetic treatments available at Dr Hawkes Clinic in London."
        pathname="/all-services/"
      />

      {/* Hero */}
      <div className="bg-white2 text-blackNew">
        <div
          className={`${containerClasses.container} py-12 md:py-20 lg:py-20`}
        >
          <div className="col-span-4 md:col-span-8 lg:col-span-6 lg:col-start-4">
            <p className="my-0 text-center md:col-span-8 lg:mt-4 overline">
              Services
            </p>
            <h2 className="mt-4 mb-0 text-center fluid-heading-05">
              Expert clinical care from an <i>award-winning</i> clinic
            </h2>
          </div>
        </div>
      </div>

      {/* Service 1 */}
      <div className="bg-white2">
        <div className={`${containerClasses.container} pt-0 pb-6`}>
          <div className="col-span-4 md:col-span-8 lg:col-span-5">
            <img
              loading="lazy"
              alt="Close-up of a woman's face with a ruler being used to measure the area near her eyebrow for precision."
              src={serviceOculXs}
            />
          </div>
          <div className="flex flex-col col-span-4 md:col-span-8 lg:col-span-5 lg:col-start-8 lg:justify-center">
            <h3 className="mt-0 mb-2 fluid-heading-04 lg:mb-4">
              <span className="mr-2 text-gold600">01/</span>
              Oculoplastic Surgery
            </h3>
            <p className="mt-0 mb-2 lg:mb-0 lg:mt-1">
              Dr Hawkes Clinic offers a range of specialised Oculoplastic
              Surgical Procedures, led by one of London&apos;s foremost
              Oculoplastic Surgeons. Our procedures include:
            </p>
            <ul className="pb-0 pl-8 mt-2 text-sm font-light list-disc md:text-base">
              <li>Blepharoplasty Surgery</li>
              <li>Brow Lift Surgery</li>
              <li>Chalazions (Stys) Removal &amp; Management</li>
              <li>Ectropion &amp; Entropion Treatment</li>
              <li>Eyelid Lump Diagnosis &amp; Removal</li>
              <li>Ptosis (Droopy Eyelid) Correction</li>
              <li>Watery Eye Solutions</li>
              <li>Xanthelasma Removal</li>
            </ul>
          </div>
        </div>

        {/* Service 2 */}
        <div className={`${containerClasses.container} py-6`}>
          <div className="col-span-4 md:col-span-8 lg:col-span-5 lg:col-start-8">
            <img
              loading="lazy"
              alt="Dr Hawkes in a white coat, sitting beside a medical microscope, with a bright and professional setting in the background."
              src={serviceOphthXs}
            />
          </div>
          <div className="flex flex-col col-span-4 md:col-span-8 lg:col-span-5 lg:col-start-1 lg:row-start-1 lg:justify-center">
            <h3 className="mt-0 mb-2 fluid-heading-04 lg:mb-4">
              <span className="mr-2 text-gold600">02/</span>
              Ophthalmology
            </h3>
            <p className="mt-0 mb-2 lg:mb-0 lg:mt-1">
              Dr Hawkes Clinic provides an extensive range of Ophthalmology
              services to address a wide variety of eye-related concerns,
              including:
            </p>
            <ul className="pb-0 pl-8 mt-2 text-sm font-light list-disc md:text-base">
              <li>Blepharitis Assessment</li>
              <li>Blephex &amp; Recurrent Sty Treatment</li>
              <li>Cataract Surgery</li>
              <li>Dry Eye Management</li>
              <li>General &amp; Urgent Ophthalmology</li>
              <li>Laser Surgery – YAG Posterior Capsulotomy</li>
              <li>Under Eye Bag Solutions</li>
            </ul>
          </div>
        </div>

        {/* Service 3 */}
        <div
          className={`${containerClasses.container} pt-6 pb-12 md:pt-12 md:pb-20`}
        >
          <div className="col-span-4 md:col-span-8 lg:col-span-5">
            <img
              loading="lazy"
              alt="Close-up of a woman having dots marked on her forehead with a soft eyeliner pencil by a professional wearing blue gloves."
              src={serviceAesthXs}
            />
          </div>
          <div className="flex flex-col col-span-4 md:col-span-8 lg:col-span-5 lg:col-start-8 lg:justify-center">
            <h3 className="mt-0 mb-2 fluid-heading-04 lg:mb-4">
              <span className="mr-2 text-gold600">03/</span>
              Aesthetics
            </h3>
            <p className="mt-0 mb-2 lg:mb-0 lg:mt-1">
              Dr Hawkes Clinic offers a carefully curated range of advanced
              aesthetic treatments, each tailored to the individual patient. Our
              treatments include:
            </p>
            <ul className="pb-0 pl-8 mt-2 text-sm font-light list-disc md:text-base">
              <li>Anti-Wrinkle Injections</li>
              <li>Ameela Polynucleotides</li>
              <li>AQUAGOLD&reg; Fine Touch Facial</li>
              <li>Clarius HD3 Ultrasound</li>
              <li>Dark Circle Solutions</li>
              <li>Dermal Fillers</li>
              <li>Morpheus 8</li>
              <li>Non-Surgical Brow Lift</li>
              <li>Polynucleotides</li>
              <li>PRP (Platelet Rich Plasma) Facial</li>
              <li>Profhilo&reg;</li>
              <li>Sculptra&reg;</li>
              <li>Tear Trough Fillers</li>
            </ul>
          </div>
        </div>
      </div>

      <CTABlock />
      <AffiliateList />
    </Layout>
  )
}

export default AllServices
